import { InjectionToken, Signal } from '@angular/core';
import { Gateway } from '@wheere/api-site';

/** Ce que l'onglet de configuration lit du site chargé par l'application hôte. */
export interface SiteConfigSite {
  id?: string;
  name?: string;
  /** Slug du site : nom des signal.json exportés (`<SLUG>_GW<n>_signal.json`, ADR-039). */
  slug?: string;
  size?: number;
  organizationId?: string | null;
  /** Miroir legacy de l'organisation (inside). */
  customerId?: string | null;
  activePresetId?: string | null;
}

/**
 * Contrat entre l'onglet « Configuration » partagé et l'application qui l'héberge (inside :
 * `SitesStore` ; integrator : adaptateur sur `IntegratorSiteService` + `SitesV7HttpClient`).
 * Chaque app garde son propre chargement et ses propres appels, le composant ne connaît que ça.
 */
export interface SiteConfigHost {
  /** Site courant (après {@link loadById}). */
  selected: Signal<SiteConfigSite | null | undefined>;
  /** Gateways du site courant, avec leurs antennes (`Gateway.antennas`). */
  selectedGateways: Signal<Gateway[] | null | undefined>;
  /** Charge (ou recharge) le site et ses gateways. */
  loadById(id: string): Promise<SiteConfigSite | null | undefined>;
  /** `DELETE /sites/{id}/clean`. `false` = échec déjà signalé à l'utilisateur. */
  cleanSite(id: string): Promise<boolean>;
}

export const SITE_CONFIG_HOST = new InjectionToken<SiteConfigHost>('SITE_CONFIG_HOST');

/** Position renvoyée par un relevé RTK. */
export interface SiteConfigRtkPosition {
  latitude: number;
  longitude: number;
  altitude: number;
}
